import { render, staticRenderFns } from "./ListClientes.vue?vue&type=template&id=43add28a&"
import script from "./ListClientes.vue?vue&type=script&lang=js&"
export * from "./ListClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports